<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="600"
  >
    <a-form
      :model="formState"
      :rules="rules"
      ref="formRef"
      layout="inline"
      :label-col="{ style: { width: '80px' } }"
      :wrapper-col="{ style: { width: '180px' } }"
    >
      <a-form-item label="抽查组员" name="spotCheckPerson">
        <a-input
          v-model:value="formState.spotCheckPerson"
          placeholder="请输入抽查组员"
          auto-size
          allowClear
        ></a-input>
      </a-form-item>
      <a-form-item label="抽查内容" name="spotCheckContent">
        <a-input
          v-model:value="formState.spotCheckContent"
          placeholder="请输入抽查内容"
          allowClear
        ></a-input>
      </a-form-item>

      <a-form-item label="计划数量" name="plannedNumber">
        <a-input-number
          v-model:value="formState.plannedNumber"
          placeholder="请输入计划数量"
          :step="1"
          allowClear
          style="width: 180px"
        >
        </a-input-number>
      </a-form-item>
      <a-form-item label="完成数量" name="currentCompletedNumber">
        <a-input-number
          v-model:value="formState.currentCompletedNumber"
          placeholder="请输入完成数量"
          style="width: 180px"
          :step="1"
          allowClear
        >
        </a-input-number>
      </a-form-item>

      <a-form-item label="进度评估" name="progressEvaluation">
        <a-select
          v-model:value="formState.progressEvaluation"
          placeholder="请选择进度评估"
          allowClear
        >
          <a-select-option value="达标">达标</a-select-option>
          <a-select-option value="未达标">未达标</a-select-option>
        </a-select>
      </a-form-item>

      <template v-if="formState.progressEvaluation === '未达标'">
        <a-form-item label="原因" name="reason">
          <a-textarea
            v-model:value="formState.reason"
            placeholder="请输入原因"
            auto-size
            allowClear
          ></a-textarea>
        </a-form-item>

        <a-form-item label="批评教育" name="isEducation">
          <a-select
            v-model:value="formState.isEducation"
            placeholder="请输入批评教育"
            allowClear
          >
            <a-select-option :value="true">是</a-select-option>
            <a-select-option :value="false">否</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="员工态度" name="employeeAttitude">
          <a-select
            v-model:value="formState.employeeAttitude"
            placeholder="请输入员工态度"
            allowClear
          >
            <a-select-option value="诚恳">诚恳</a-select-option>
            <a-select-option value="不接受">不接受</a-select-option>
            <a-select-option value="勉强接受">勉强接受</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="培训" name="isTrain">
          <a-select
            v-model:value="formState.isTrain"
            placeholder="请选择培训"
            allowClear
          >
            <a-select-option :value="true">是</a-select-option>
            <a-select-option :value="false">否</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="首样确认" name="firstConfirm">
          <a-select
            v-model:value="formState.firstConfirm"
            placeholder="请选择首样确认"
            allowClear
          >
            <a-select-option value="合格">合格</a-select-option>
            <a-select-option value="不合格">不合格</a-select-option>
          </a-select>
        </a-form-item>
      </template>
    </a-form>
  </a-modal>
</template>

<script>
import { timeStampToTime, Toast } from "@/utils";
import { computed, defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import { showUploading, hideUploading } from "@/utils/index";
import {
  saveOrUpdateCapacitySpotCheck,
  uploadProduceAttachment,
} from "@/request/view/product";
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";

export default defineComponent({
  props: {
    type: String,
    produceOrTpc: String,
  },
  components: { uploadImgVue, uploadVideoVue },
  setup(props, context) {
    const store = useStore();
    const formRef = ref();
    const modalConfig = reactive({
      visible: false,
      title: null,
    });
    const imgRef = ref();
    const videoRef = ref();

    const formState = reactive({
      id: null,
      currentCompletedNumber: null,
      employeeAttitude: null,
      isEducation: null,
      isTrain: null,
      firstConfirm: null,
      localDate: null,
      plannedNumber: null,
      produceOrTpc: null,
      progressEvaluation: null,
      project: "swan",
      reason: null,
      userId: null,
      username: null,
      spotCheckContent: null,
      spotCheckPerson: null,
    });

    const isEdit = computed(() => {
      if (modalConfig.title === "添加质检数据") {
        return true;
      }
      return formState.userId === store.state.user.user.id;
    });

    const rules = {
      spotCheckContent: [
        {
          required: true,
          message: "请输入抽查内容",
          trigger: "change",
          type: "any",
        },
      ],
      spotCheckPerson: [
        {
          required: true,
          message: "请输入抽查组员",
          trigger: "change",
          type: "any",
        },
      ],
      // plannedNumber: [
      //   {
      //     required: true,
      //     message: "请输入计划数量",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // currentCompletedNumber: [
      //   {
      //     required: true,
      //     message: "请输入完成数量",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      updateCapacitySpotCheck: [
        {
          required: true,
          message: "请选择抽查情况",
          trigger: "change",
          type: "any",
        },
      ],
      progressEvaluation: [
        {
          required: true,
          message: "请输入进度评估",
          trigger: "change",
          type: "any",
        },
      ],
      // reason: [
      //   {
      //     required: true,
      //     message: "请输入原因",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // isEducation: [
      //   {
      //     required: true,
      //     message: "请选择批评教育",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // employeeAttitude: [
      //   {
      //     required: true,
      //     message: "请选择员工态度",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // isTrain: [
      //   {
      //     required: true,
      //     message: "请选择培训",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      firstConfirm: [
        {
          required: true,
          message: "请选择首样确认",
          trigger: "change",
          type: "any",
        },
      ],
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.visible = false;
      modalConfig.title = null;
    };

    const openModal = (type, data) => {
      modalConfig.visible = true;
      if (type === "addeditUpdateCapacitySpotCheck") {
        modalConfig.title = "添加产能抽查";
        formState.localDate = timeStampToTime("", "upload");
        const { id, username } = store.state.user.user;
        formState.userId = id;
        formState.username = username;
        formState.type = props.type;
        formState.project = "swan";
        formState.produceOrTpc = props.produceOrTpc;
        console.log(formState, "获取的数据是什么");
      } else if (type === "editUpdateCapacitySpotCheck") {
        modalConfig.title = "编辑产能抽查";
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }
    };

    const handleOk = () => {
      try {
        formRef.value
          .validate()
          .then(async () => {
            showUploading();

            await saveOrUpdateCapacitySpotCheck(formState)
              .then((res) => {
                let type = res.code === 200 ? "success" : "warning";
                Toast(type, res.message, 3);
                handleCancel();
                context.emit("updateTable");
                hideUploading();
              })
              .catch((err) => {
                console.log(err);
                hideUploading();
              });
          })
          .catch((err) => {
            console.log(err, "捕获错误");
            if (err.errorFields && err.errorFields.length > 0) {
              const [errText] = err.errorFields[0].errors;
              Toast("warning", errText, 3);
            }
          });
      } catch (error) {
        console.log(error, "catch 捕获错误");
      }
    };

    return {
      formRef,
      openModal,
      modalConfig,
      handleOk,
      handleCancel,
      formState,
      rules,
      isEdit,
      imgRef,
      videoRef,
      uploadProduceAttachment,
    };
  },
});
</script>

<style lang="less" scoped>
:deep(.ant-form-item) {
  margin-bottom: 8px;
}
</style>
